import type { SupportedLocale } from "./locales"

export const LOCALE_OPTIONS: Array<{
  value: SupportedLocale
  labelKey: "language.english" | "language.french" | "language.spanish"
}> = [
  { value: "en", labelKey: "language.english" },
  { value: "fr", labelKey: "language.french" },
  { value: "es", labelKey: "language.spanish" },
]
